/**
 * Import
 * - Libraries
 */
import * as React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

/**
 * Import
 * - Store
 */
import { RootState } from '../store'
/**
 * Import
 * - Components
 */
import Loading from '../components/common/Loading/Loading'

/**
 * Map variables from global state to component props
 * @return {object} [description]
 */
const mapStateToProps = (state: RootState) => {
    return {
        user: state.user,
    }
}

class RouteValidator extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    render() {

        let loadingStyle = {
            position: 'absolute',
            top: '50%',
            left: '50%',
        }

        if (this.props.user.loading) {
            return (<div><Loading style={loadingStyle} /></div>)
        } else if (!this.props.user.error) {
            if (Object.keys(this.props.user.session).length !== 0 || Object.keys(this.props.user.user).length !== 0) {
                return (
                    <div>
                        {this.props.children}
                    </div>
                )
            } else {
                return (<Redirect to="/login" />)
            }
        } else {
            return (<div>There's been some errors</div>)
        }
    }
}

/**
 * Connect (props, dispach functions)(component)
 */
export default connect(mapStateToProps)(RouteValidator)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/RouteValidator.tsx